// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mrWE","label":"styles_label__3gMOg"};